import styled from "styled-components";

export const Page = styled.main`
  background: #0e1a24;
`;

export const Section = styled.section`
  background: ${({ $variant }) =>
    $variant === "light" ? "#f9f9f9" : "#0E1A24"};
  color: ${({ $variant }) => ($variant === "light" ? "#0E1A24" : "#f7f8fa")};
  padding: 42px 0;

  @media screen and (max-width: 768px) {
    padding: 56px 0;
  }
`;

export const HeroSection = styled(Section)`
  position: relative;
  overflow: hidden;

  background-image: url(${({ $bg }) => $bg});
  background-size: cover;
  background-position: right center;
  background-repeat: no-repeat;

  padding-top: 120px;

  @media screen and (max-width: 768px) {
    background-position: 50% center;
    padding-top: 104px;
  }
`;

export const Container = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 24px;
`;

export const TopLine = styled.p`
  color: #ffcb66;
  font-size: 20px;
  line-height: 18px;
  font-weight: 700;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  margin-bottom: 12px;
`;

export const H1 = styled.h1`
  font-size: 44px;
  line-height: 52px;
  margin: 0 0 14px 0;

  @media screen and (max-width: 768px) {
    font-size: 34px;
    line-height: 40px;
  }
`;

export const Lead = styled.p`
  font-size: 18px;
  line-height: 28px;
  margin: 0;
  opacity: 0.95;
  max-width: 820px;
`;
